import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';

export const VALUATION_CARD_ACTIONS = [
	{
		label: 'deal_card_menu.delete',
		value: 'DELETE',
		icon: <Icon variant="delete" size="lg" />,
	},
	{
		label: 'deal_card_menu.duplicate',
		value: 'DUPLICATE',
		icon: <Icon variant="copy" size="lg" />,
	},
] as const;
